import { render, staticRenderFns } from "./CategoryPrivilegeTable.vue?vue&type=template&id=1f9d6602&"
import script from "./CategoryPrivilegeTable.vue?vue&type=script&lang=js&"
export * from "./CategoryPrivilegeTable.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPrivilegeTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports